/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Concession} from '../bioplanModels';
// @ts-ignore
import type {UnallocatedBiomass} from '../bioplanModels';
/**
 * PlanningConcessionApi - axios parameter creator
 * @export
 */
export const PlanningConcessionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete concession by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsConcessionIdDelete: async (
      concessionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'concessionId' is not null or undefined
      assertParamExists('concessionsConcessionIdDelete', 'concessionId', concessionId);
      const localVarPath = `/concessions/{concessionId}`.replace(
        `{${'concessionId'}}`,
        encodeURIComponent(String(concessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get concessions for a plan by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsConcessionIdGet: async (
      concessionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'concessionId' is not null or undefined
      assertParamExists('concessionsConcessionIdGet', 'concessionId', concessionId);
      const localVarPath = `/concessions/{concessionId}`.replace(
        `{${'concessionId'}}`,
        encodeURIComponent(String(concessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update concession for a plan
     * @param {string} concessionId
     * @param {Concession} concession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsConcessionIdPut: async (
      concessionId: string,
      concession: Concession,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'concessionId' is not null or undefined
      assertParamExists('concessionsConcessionIdPut', 'concessionId', concessionId);
      // verify required parameter 'concession' is not null or undefined
      assertParamExists('concessionsConcessionIdPut', 'concession', concession);
      const localVarPath = `/concessions/{concessionId}`.replace(
        `{${'concessionId'}}`,
        encodeURIComponent(String(concessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(concession, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all concessions for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('concessionsGet', 'planId', planId);
      const localVarPath = `/concessions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create concession for a plan
     * @param {Concession} concession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsPost: async (concession: Concession, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'concession' is not null or undefined
      assertParamExists('concessionsPost', 'concession', concession);
      const localVarPath = `/concessions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(concession, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsUnallocatedBiomassPlanIdGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('concessionsUnallocatedBiomassPlanIdGet', 'planId', planId);
      const localVarPath = `/concessions/unallocatedBiomass/{planId}`.replace(
        `{${'planId'}}`,
        encodeURIComponent(String(planId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningConcessionApi - functional programming interface
 * @export
 */
export const PlanningConcessionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningConcessionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete concession by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async concessionsConcessionIdDelete(
      concessionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.concessionsConcessionIdDelete(concessionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningConcessionApi.concessionsConcessionIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get concessions for a plan by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async concessionsConcessionIdGet(
      concessionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Concession>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.concessionsConcessionIdGet(concessionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningConcessionApi.concessionsConcessionIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update concession for a plan
     * @param {string} concessionId
     * @param {Concession} concession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async concessionsConcessionIdPut(
      concessionId: string,
      concession: Concession,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Concession>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.concessionsConcessionIdPut(
        concessionId,
        concession,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningConcessionApi.concessionsConcessionIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all concessions for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async concessionsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Concession>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.concessionsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningConcessionApi.concessionsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create concession for a plan
     * @param {Concession} concession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async concessionsPost(
      concession: Concession,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Concession>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.concessionsPost(concession, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningConcessionApi.concessionsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async concessionsUnallocatedBiomassPlanIdGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UnallocatedBiomass>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.concessionsUnallocatedBiomassPlanIdGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningConcessionApi.concessionsUnallocatedBiomassPlanIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningConcessionApi - factory interface
 * @export
 */
export const PlanningConcessionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningConcessionApiFp(configuration);
  return {
    /**
     *
     * @summary Delete concession by its identifier
     * @param {PlanningConcessionApiConcessionsConcessionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsConcessionIdDelete(
      requestParameters: PlanningConcessionApiConcessionsConcessionIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .concessionsConcessionIdDelete(requestParameters.concessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get concessions for a plan by its identifier
     * @param {PlanningConcessionApiConcessionsConcessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsConcessionIdGet(
      requestParameters: PlanningConcessionApiConcessionsConcessionIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Concession> {
      return localVarFp
        .concessionsConcessionIdGet(requestParameters.concessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update concession for a plan
     * @param {PlanningConcessionApiConcessionsConcessionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsConcessionIdPut(
      requestParameters: PlanningConcessionApiConcessionsConcessionIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Concession> {
      return localVarFp
        .concessionsConcessionIdPut(requestParameters.concessionId, requestParameters.concession, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all concessions for a plan
     * @param {PlanningConcessionApiConcessionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsGet(
      requestParameters: PlanningConcessionApiConcessionsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Concession>> {
      return localVarFp.concessionsGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create concession for a plan
     * @param {PlanningConcessionApiConcessionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsPost(
      requestParameters: PlanningConcessionApiConcessionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Concession> {
      return localVarFp
        .concessionsPost(requestParameters.concession, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get cages with unallocated biomass
     * @param {PlanningConcessionApiConcessionsUnallocatedBiomassPlanIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    concessionsUnallocatedBiomassPlanIdGet(
      requestParameters: PlanningConcessionApiConcessionsUnallocatedBiomassPlanIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<UnallocatedBiomass>> {
      return localVarFp
        .concessionsUnallocatedBiomassPlanIdGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for concessionsConcessionIdDelete operation in PlanningConcessionApi.
 * @export
 * @interface PlanningConcessionApiConcessionsConcessionIdDeleteRequest
 */
export interface PlanningConcessionApiConcessionsConcessionIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningConcessionApiConcessionsConcessionIdDelete
   */
  readonly concessionId: string;
}

/**
 * Request parameters for concessionsConcessionIdGet operation in PlanningConcessionApi.
 * @export
 * @interface PlanningConcessionApiConcessionsConcessionIdGetRequest
 */
export interface PlanningConcessionApiConcessionsConcessionIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningConcessionApiConcessionsConcessionIdGet
   */
  readonly concessionId: string;
}

/**
 * Request parameters for concessionsConcessionIdPut operation in PlanningConcessionApi.
 * @export
 * @interface PlanningConcessionApiConcessionsConcessionIdPutRequest
 */
export interface PlanningConcessionApiConcessionsConcessionIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningConcessionApiConcessionsConcessionIdPut
   */
  readonly concessionId: string;

  /**
   *
   * @type {Concession}
   * @memberof PlanningConcessionApiConcessionsConcessionIdPut
   */
  readonly concession: Concession;
}

/**
 * Request parameters for concessionsGet operation in PlanningConcessionApi.
 * @export
 * @interface PlanningConcessionApiConcessionsGetRequest
 */
export interface PlanningConcessionApiConcessionsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningConcessionApiConcessionsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for concessionsPost operation in PlanningConcessionApi.
 * @export
 * @interface PlanningConcessionApiConcessionsPostRequest
 */
export interface PlanningConcessionApiConcessionsPostRequest {
  /**
   *
   * @type {Concession}
   * @memberof PlanningConcessionApiConcessionsPost
   */
  readonly concession: Concession;
}

/**
 * Request parameters for concessionsUnallocatedBiomassPlanIdGet operation in PlanningConcessionApi.
 * @export
 * @interface PlanningConcessionApiConcessionsUnallocatedBiomassPlanIdGetRequest
 */
export interface PlanningConcessionApiConcessionsUnallocatedBiomassPlanIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningConcessionApiConcessionsUnallocatedBiomassPlanIdGet
   */
  readonly planId: string;
}

/**
 * PlanningConcessionApi - object-oriented interface
 * @export
 * @class PlanningConcessionApi
 * @extends {BaseAPI}
 */
export class PlanningConcessionApi extends BaseAPI {
  /**
   *
   * @summary Delete concession by its identifier
   * @param {PlanningConcessionApiConcessionsConcessionIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningConcessionApi
   */
  public concessionsConcessionIdDelete(
    requestParameters: PlanningConcessionApiConcessionsConcessionIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningConcessionApiFp(this.configuration)
      .concessionsConcessionIdDelete(requestParameters.concessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get concessions for a plan by its identifier
   * @param {PlanningConcessionApiConcessionsConcessionIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningConcessionApi
   */
  public concessionsConcessionIdGet(
    requestParameters: PlanningConcessionApiConcessionsConcessionIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningConcessionApiFp(this.configuration)
      .concessionsConcessionIdGet(requestParameters.concessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update concession for a plan
   * @param {PlanningConcessionApiConcessionsConcessionIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningConcessionApi
   */
  public concessionsConcessionIdPut(
    requestParameters: PlanningConcessionApiConcessionsConcessionIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningConcessionApiFp(this.configuration)
      .concessionsConcessionIdPut(requestParameters.concessionId, requestParameters.concession, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all concessions for a plan
   * @param {PlanningConcessionApiConcessionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningConcessionApi
   */
  public concessionsGet(
    requestParameters: PlanningConcessionApiConcessionsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningConcessionApiFp(this.configuration)
      .concessionsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create concession for a plan
   * @param {PlanningConcessionApiConcessionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningConcessionApi
   */
  public concessionsPost(
    requestParameters: PlanningConcessionApiConcessionsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningConcessionApiFp(this.configuration)
      .concessionsPost(requestParameters.concession, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get cages with unallocated biomass
   * @param {PlanningConcessionApiConcessionsUnallocatedBiomassPlanIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningConcessionApi
   */
  public concessionsUnallocatedBiomassPlanIdGet(
    requestParameters: PlanningConcessionApiConcessionsUnallocatedBiomassPlanIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningConcessionApiFp(this.configuration)
      .concessionsUnallocatedBiomassPlanIdGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
